import React, {Component} from 'react';
import {IonContent} from '@ionic/react';
import "../ContestDetailPage.css"
import {History} from "history";
import Map from "./Map";
import Contest from "../../domain/Contest";

type Props = {
  history: History;
  contest: Contest;
};

type State = {}

export default class ContestDetailInfoTab extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <IonContent>
        <div className="contest-detail-map-tab">
          <Map contest={this.props.contest} locations={[this.props.contest.location]} mapCenter={this.props.contest.location}/>
        </div>
      </IonContent>
    );
  }
}
